import * as React from 'react';

import { Organization, User } from '@rematter/frontend-lib-api-client';

import { Impersonation } from './identity.localState';

export interface IdentityContextValue {
  accessToken: string | null;
  user: User | null;
  organization: Organization | null;
  impersonator: Impersonation | null;
  facilityId: string | null;
  isLoading: boolean;
  isLoggedIn: boolean;
  setAccessToken: (accessToken: string) => void;
  setUser: (user: User) => void;
  setOrganization: (organization: Organization) => void;
  setFacilityId: (facilityId: string | null) => void;
  signOut: () => Promise<void>;
}

export const IdentityContext = React.createContext<IdentityContextValue | null>(
  null,
);
